module["exports"] = ["no", "com", "net", "org"];